import { useReportContext } from "../../../report-context";

import { ToastType } from "@/enums";
import { BlockType, blockTypeToRawBlockType } from "@/components/PowerBlock/Blocks";
import { ColumnType } from "@/types/evaluate";
import { displayToast } from "@/utils/toast";

const useColumnTypeHandler = () => {
  const reportContext = useReportContext();
  const { selectedColumn } = reportContext;

  const handleTypeChange = (blockType: BlockType) => {
    if (!selectedColumn) {
      return;
    }

    try {
      const newColumn = {
        ...selectedColumn,
        configuration: {},
        column_type: blockTypeToRawBlockType(blockType) as unknown as ColumnType,
      };

      reportContext.setSelectedColumn(newColumn);
    } catch {
      displayToast("Failed to change block type", ToastType.error);
    }
  };

  return {
    handleTypeChange,
  };
};

export default useColumnTypeHandler;
